import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ProviderStatementEmailTemplate.UploadAttachment.IRequest;
type Response = Api.Core.ProviderStatementEmailTemplate.UploadAttachment.IResponse;
type Headers = Api.Core.ProviderStatementEmailTemplate.UploadAttachment.IHeaders;
const apiProviderStatementEmailTemplateUploadAttachmentPath =
  '/api/Management/ProviderStatementEmailTemplate/:id/UploadAttachment';
export default async function providerStatementEmailTemplateUploadAttachmentApi(
  id: number,
  request: Request
): Promise<Api.Res<Response>> {
  const res = await executeServerApi<Request, Response, Headers>({
    body: request,
    url: createPathFromRoute(apiProviderStatementEmailTemplateUploadAttachmentPath, { id }, null),
    method: HttpMethod.post,
    headers: getDefaultHeaders(),
  });
  return res;
}
